import { render, staticRenderFns } from "./SidebarLight.vue?vue&type=template&id=360995e0&scoped=true&"
import script from "./SidebarLight.vue?vue&type=script&lang=js&"
export * from "./SidebarLight.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLight.vue?vue&type=style&index=0&id=360995e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360995e0",
  null
  
)

export default component.exports